<template>
  <b-button
    inline-block
    :disabled="disabled"
    class="confirm-btn"
    :variant="variant"
    v-on:click="onClick"
    >{{ label }}</b-button
  >
</template>

<style lang="scss" scoped>
.confirm-btn {
  width: 167px;
  height: 42px;
  font-size: 16px;
  font-weight: bold;

  &.disabled {
    background-color: #e2e2e2;
    border-color: #e2e2e2;
    color: #b3b3b3;
    opacity: 1;
    cursor: not-allowed;
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "confirm",
  props: {
    label: { type: String, default: "確認", required: true },
    disabled: { type: Boolean, default: false },
    variant: { type: String, default: "info" },
  },
  setup(_props, { emit }) {
    const onClick = (): void => {
      emit("confirm");
    };
    return { onClick };
  },
});
</script>
